'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _circleButton = require('./circleButton.scss');

var _circleButton2 = _interopRequireDefault(_circleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleButton = function (_React$Component) {
    (0, _inherits3.default)(CircleButton, _React$Component);

    function CircleButton(props, context) {
        (0, _classCallCheck3.default)(this, CircleButton);
        return (0, _possibleConstructorReturn3.default)(this, (CircleButton.__proto__ || (0, _getPrototypeOf2.default)(CircleButton)).call(this, props));
    }

    (0, _createClass3.default)(CircleButton, [{
        key: 'render',
        value: function render() {
            //let idBtn = (this.props.id) ? (this.props.id) : '';
            var actionBtn = this.props.action ? this.props.action : '';
            var textBtn = this.props.text ? this.props.text : '';
            var customClassBtn = this.props.customClassBtn ? this.props.customClassBtn : '';
            var icon = this.props.icon ? _react2.default.createElement('i', { className: "icon " + this.props.icon }) : '';
            var typeBottom = '';
            if (this.props.bottonLine) {
                typeBottom = _react2.default.createElement(
                    'div',
                    { className: 'arrowCarousel', onClick: this.goNext },
                    _react2.default.createElement(
                        'span',
                        { className: 'smallTitle' },
                        'Next'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'statusLoading' },
                        _react2.default.createElement(
                            'div',
                            { className: 'barStatus' },
                            _react2.default.createElement('span', { id: 'barPercent' })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'iconContainer' },
                            ' -> '
                        )
                    )
                );
            } else {
                typeBottom = _react2.default.createElement(
                    'div',
                    null,
                    textBtn,
                    icon
                );
            }
            return _react2.default.createElement(
                'div',
                { className: "circleButton " + customClassBtn, onClick: actionBtn },
                typeBottom
            );
        }
    }]);
    return CircleButton;
}(_react2.default.Component);

exports.default = CircleButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Buttons/CircleButton.jsx
// module id = 712
// module chunks = 0